import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';
import { Component } from '@angular/core';

export class MssqlWrapper extends DatabaseWrapper {

	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.mssql.ID;
		this.name = DatabaseEnum.mssql.NAME;
		this.code = DatabaseEnum.mssql.CODE;
		this.equivalentTag = DatabaseEnum.mssql.EQUIVALENT_TAG;
		this.databaseNm = 'default';
		this.schemaNm = 'dbo';
		this.isCDC = true;
		//data object tabs
		this.showDataObjectPropertiesTab = true;
		this.hideDatabaseNmDbColumn = true;
		this.hideSchemaNmColumn = false;
		this.showDDLOption = true;
		this.showViewDataTabOption = true;
		this.isShowObjProperties = true;
		this.isShowPIIColumn = true;
		this.dataObjectConnDatabaseNm = 'Schema';
		this.getSchemasOnDbNm = true;
    this.showDataDescription = false;
	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {
		if (repConnWrapper.repConn.conn.host == "") {
			repConnWrapper.inValid_Cds.push('NO_HOST');
		}

		if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
			repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
		}

		if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
			repConnWrapper.inValid_Cds.push('NO_PASSWORD');
		}


		if (repConnWrapper.repConn.conn_Dbs.length != 0) {
			if (repConnWrapper.repConn.conn_Dbs[0].databaseNm == "") {
				repConnWrapper.inValid_Cds.push('NO_DATABASE_NM');
			}
		}

		if( repConnWrapper.repConn.conn.connType == 'Azure SQL Database') {
			if (repConnWrapper.repConn.conn.port == CommonEnums.defaults.STRING_EMPTY) {
				repConnWrapper.inValid_Cds.push('NO_PORT');
			}
		} else {
			if (!this.isNamedInstance) {
				if (repConnWrapper.repConn.conn.port == CommonEnums.defaults.STRING_EMPTY) {
					repConnWrapper.inValid_Cds.push('NO_PORT');
				}
			}

			if (this.isNamedInstance) {
				if (repConnWrapper.repConn.conn.instSqlNm == CommonEnums.defaults.STRING_EMPTY) {
					repConnWrapper.inValid_Cds.push('NO_INSTANCE');
				}
			}
		}



		if (repConnWrapper.repConn.conn.access_Token_Flg == 'Y') {
			if (repConnWrapper.repConn.conn.codePage == "Azure Key Vault") {
				if (repConnWrapper.repConn.conn.ssl_trustStore == "")
					repConnWrapper.inValid_Cds.push('NO_CLIENTID');
				else if (repConnWrapper.repConn.conn.ssl_keyStorePassword == "")
					repConnWrapper.inValid_Cds.push('NO_CLIENTKEY');
			} else if (repConnWrapper.repConn.conn.codePage == "Java Key Store") {
				if (repConnWrapper.repConn.conn.ssl_keyStore == "")
					repConnWrapper.inValid_Cds.push('NO_KEYSTORELOC');
				else if (repConnWrapper.repConn.conn.ssl_trustStorePassword == "")
					repConnWrapper.inValid_Cds.push('NO_KEYSTOREPASS');
			}
		}

		if (repConnWrapper.repConn.conn.authentication == "SSL") {
			if (repConnWrapper.repConn.conn.ssl_trustStore == undefined || repConnWrapper.repConn.conn.ssl_trustStore == "") {
				repConnWrapper.inValid_Cds.push('NO_SSLTRUSTCERT');
			}

			if (repConnWrapper.repConn.conn.ssl_keyStorePassword == undefined || repConnWrapper.repConn.conn.ssl_keyStorePassword == "") {
				repConnWrapper.inValid_Cds.push('NO_SSLTRUSTCERTPWD');

			}
		}

		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}

		if (repConnWrapper.repConn.conn_Dbs.length < 1) {
			repConnWrapper.inValid_Cds.push('NO_DATABASE');
		}
	}

	//isEncryptedFlag: boolean

	getAttributeColumns(objectWrapper: ObjectWrapper,
		attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getMaxFlag(objectWrapper, true),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, true),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, true),
			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getIdentityFlag(objectWrapper),

			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false, isMax: boolean = false, component: any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getMaxFlag(objectWrapper, true),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}

	// getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
	// 	return [
	// 		this.attributeTabulator.getCheckBoxColumn(objectWrapper),
	// 		this.lAttributeTabulator.getSrt_Order(),
	// 		this.lAttributeTabulator.getLAttr_Id(),
	// 		this.lAttributeTabulator.getLAttrNm(objectWrapper),
	// 		this.lAttributeTabulator.getSelectColumn(objectWrapper),
	// 		this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
	// 		this.lAttributeTabulator.getLAttrPrec(objectWrapper),
	// 		this.lAttributeTabulator.getLAttrScale(objectWrapper),
	// 		this.lAttributeTabulator.getLAttrType(objectWrapper),
	// 		this.lAttributeTabulator.getLAttrFunction(objectWrapper),
	// 		this.lAttributeTabulator.getDistKeyFlag(objectWrapper),
	// 		this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
	// 		this.lAttributeTabulator.getPartFlag(objectWrapper),
	// 		this.lAttributeTabulator.getOrderBy(objectWrapper)
	// 	]
	// }

	getLAttributeColumns(objectWrapper: ObjectWrapper, component): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.lAttributeTabulator.getSrt_Order(),
			this.lAttributeTabulator.getLAttr_Id(),
			this.lAttributeTabulator.getLAttrNm(objectWrapper),
			this.lAttributeTabulator.getSelectColumn(objectWrapper),
			this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
			this.lAttributeTabulator.getLAttrPrec(objectWrapper),
			this.lAttributeTabulator.getLAttrScale(objectWrapper),
			this.lAttributeTabulator.getLAttrType(objectWrapper),
			this.lAttributeTabulator.getLAttrFunction(objectWrapper),
			this.lAttributeTabulator.getLAttrmaxFlag(objectWrapper),
			this.lAttributeTabulator.getDistKeyFlag(objectWrapper, component),
			this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
			this.lAttributeTabulator.getOrderBy(objectWrapper, component),
		]
	}

	getConn_DbColumns(repConnWrapper: RepConnWrapper, component: any): Array<any> {
		return [
			this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
			this.conn_DbsTabultor.getSrt_Order(),
			this.conn_DbsTabultor.getName(repConnWrapper),
			this.conn_DbsTabultor.getDatabaseNm(repConnWrapper, component),
			//this.conn_DbsTabultor.loadShemas(repConnWrapper, component),
			this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component),
			this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper)
		]
	}

}
